import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
export const Card = (props) => {
    const { children, className = '', isRounded = false, isShadow = false, } = props;
    return (_jsx("div", Object.assign({ className: clsx('bg-white', isShadow && 'shadow-md', isRounded && 'rounded-md', className) }, { children: children })));
};
